export default (that) => [
  {
    text: that.$l('btn_shelve') || '上架',
    icon: 'el-icon-rank',
    menuType: 'batchFabricCardListing',
    allow: 'M',
    disabled: ({ fabricCardStatus }) => !['Y'].includes(fabricCardStatus),
  },
  {
    text: that.$l('menu_text_printer') || '打印面料',
    icon: 'el-icon-collection-tag',
    menuType: 'printer',
    divided: true,
    allow: 'P',
    disabled: ({ fabricCardStatus }) => !['Y'].includes(fabricCardStatus),
  },
  {
    text: that.$l('INDEX.btn_tips_del') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'D',
    disabled: ({ fabricCardStatus }) => !['Y'].includes(fabricCardStatus),
  },
]
